import { Clock } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonCmp from 'src/components/ButtonCmp';
import TooltipCmp from 'src/components/TooltipCmp';

import { useTrackMap } from './TrackMapContext';

interface IProps {
    // Matches the surrounding header's button styling: 'btn-outline-primary' on the
    // list page, 'btn_secondary_black' on the detail page.
    buttonClassName?: string;
}

/**
 * Toggles the UTC timezone-boundary overlay on the shared Radar map.
 *
 * All state lives in TrackMapLayout (via TrackMapContext) so the list and detail
 * pages stay in sync and the overlay survives theme changes made from either.
 */
const TrackTimezoneToggle: React.FC<IProps> = ({ buttonClassName = 'btn-outline-primary' }) => {
    const { t } = useTranslation();
    const { showTimezones, toggleTimezones } = useTrackMap();

    return (
        <TooltipCmp message={showTimezones ? t('Radar.Hide_Timezones') : t('Radar.Show_Timezones')} childrenClassName="flex">
            <ButtonCmp size="square-sm" className={buttonClassName} icon={<Clock className="w-4 h-4" />} onClick={toggleTimezones}>
                <></>
            </ButtonCmp>
        </TooltipCmp>
    );
};

export default TrackTimezoneToggle;
